module.exports = __webpack_public_path__ + "img/shape.a522df4a.png";